import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EntityContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {ApiVisa, BasicApiResponseModel, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from "rxjs";
import { EntityCriteriaDTO } from "../../../data-transfer-objects/entity-criteria-dto.model"
import { LoginEntityUpdateRequestDtoModel } from '../../../data-transfer-objects';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})
export class EntityService extends BaseApiPublicLoginTemplateService<EntityContainerModel, EntityContainerModel, EntityContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/login-ep';
    this.httpClient = http;
  }

  getCustomEntity(visa: ApiVisa, entityType: string):
    Observable<BasicApiResponseModel<any>> {
    let url = this.apiUrl + '/' + Core2Config.CUSTOM_PREFIX  + 'query?';
    if (entityType) {
      let url = this.apiUrl + '/' + Core2Config.CUSTOM_PREFIX  + 'query?type=' + entityType;
    }
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.CUSTOM_PREFIX  + 'query?';
      if (entityType) {
        let url = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.CUSTOM_PREFIX  + 'query?' + entityType;
      }
    }
    return this.httpClient.get<BasicApiResponseModel<any>>
    (url, this.getHttpHeader(visa));
  }

  updateEntity(
    type: any,
    entity:EntityContainerModel,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path+'/'+ type+'s/' + entity;
    return this.httpClient.put<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }

  getEntity(
    type: any,
    guid:any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path+'/'+ type+'s/' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }

  getEntityByHdrGuids(guid: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = visa.api_domain_url + this.endpoint_path + '/query?hdr_guids=' + guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url, this.getHttpHeader(visa)
    );
  }

  getEntityArapBal(guid: string, compGuid: string, docCcy: string, visa: ApiVisa): Observable<BasicApiResponseModel<number>> {
    let url = visa.api_domain_url + this.endpoint_path + '/arap_bal/' + guid + '/' + compGuid + '/' + docCcy;
    return this.httpClient.get<BasicApiResponseModel<number>>(
      url, this.getHttpHeader(visa)
    );
  }

  getEntityUsingPost(dto: EntityCriteriaDTO, apiVisa: ApiVisa): Observable<PagingResponseModel<any>> {
    let url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/query/snapshot-v2/backoffice-ep';
    return this.httpClient.post<PagingResponseModel<any>>(url, dto, this.getHttpHeader(apiVisa));
  }

  updateEntityUsingRequestDtoModel(dtoObject: LoginEntityUpdateRequestDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<EntityContainerModel>> {
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/update/backoffice-ep';
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity/update/backoffice-ep';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<EntityContainerModel>>(
      apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
